<template>
	<div
		:class="props.theme === 'dark'
			? 'tw-bg-[#151515] tw-shadow-black/20'
			: 'tw-bg-white tw-shadow-[#d5c0c0]'"
		class="
			tw-h-[10vh]
			tw-p-4
			tw-flex
			tw-flex-row
			tw-justify-between
			tw-items-center
		"
	>
		<div
			@click="navigateToAnteSilo"
			class="tw-cursor-pointer"
		>
			<i
				:class="props.theme === 'dark' ? 'tw-text-white' : 'tw-text-black'"
				class="
					fa-solid
					fa-circle-chevron-left
					tw-text-[1.8rem]
				"
			></i>
		</div>

		<div class="tw-text-center">
			<h2
				:class="props.theme === 'dark' ? 'tw-text-white' : 'tw-text-black'"
				class="tw-font-bold tw-text-2xl"
			>
				{{ silo.nome }}
			</h2>
		</div>

		<div
			@click="navigateToProxSilo"
			class="tw-cursor-pointer"
		>
			<i
				:class="props.theme === 'dark' ? 'tw-text-white' : 'tw-text-black'"
				class="
					fa-solid
					fa-circle-chevron-right
					tw-text-[1.8rem]
				"
			></i>
		</div>
	</div>
</template>

<script>
	import { useRouter } from 'vue-router';
	import { useStore } from 'vuex';
	import { ref, watch, computed } from 'vue';

	export default {
		props: {
			silo: {
				type: Object,
				required: true
			},
			unidadeId: {
				type: String,
				required: true
			},
			theme: {
				type: String,
				required: true
			}
		},

		setup(props) {
			const router = useRouter();
			const store = useStore();
			const vue_app_name = process.env.VUE_APP_NAME;
			const version = process.env.VUE_APP_VERSION;
			const silos = ref([]);

			watch(() => store.state.silos.silos,(newSilos) => {
					silos.value = newSilos;
				}, { immediate: true }
			);

			const silosOrdenados = computed(() => {
				return silos.value.slice().sort((a, b) => {
					const numA = parseInt(a.nome.match(/\d+/)[0]);
					const numB = parseInt(b.nome.match(/\d+/)[0]);
					return numA - numB;
				});
			});

			const navigateToAnteSilo = () => {
				const idSiloAtual = silosOrdenados.value.findIndex(silo => silo.id === props.silo.id);
				if (idSiloAtual > 0) {
					const idAnteSilo = silosOrdenados.value[idSiloAtual - 1].id;
					router.push(`/v2/unidades/${props.unidadeId}/silos/${idAnteSilo}`);
				} else {
					const idUltimoSilo = silosOrdenados.value[silosOrdenados.value.length - 1].id;
					router.push(`/v2/unidades/${props.unidadeId}/silos/${idUltimoSilo}`);
				}
			};

			const navigateToProxSilo = () => {
				const idSiloAtual = silosOrdenados.value.findIndex(silo => silo.id === props.silo.id);
				if (idSiloAtual < silosOrdenados.value.length - 1) {
					const idProxSilo = silosOrdenados.value[idSiloAtual + 1].id;
					router.push(`/v2/unidades/${props.unidadeId}/silos/${idProxSilo}`);
				} else {
					const idPrimeiroSilo = silosOrdenados.value[0].id;
					router.push(`/v2/unidades/${props.unidadeId}/silos/${idPrimeiroSilo}`);
				}
			};

			return {
				vue_app_name,
				version,
				navigateToAnteSilo,
				navigateToProxSilo,
				props
			};
		}
	};
</script>

